import React, { useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Swiper, SwiperSlide } from 'swiper/react';
import ConditionalRender from "../../components/Common/ConditionalRender";

import { Autoplay } from "swiper/modules";

const ImageSlider = ({ sliderData, sliderLoading }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const swiperRef = useRef(null);
  const autoPlayDelay = 3500;

  const handleSlideChange = (swiper) => {
    setActiveSlide(swiper.activeIndex);
  };
  return (
    <div className="flex flex-col relative ">
      <ConditionalRender
        productsData={sliderData}
        isLoading={sliderLoading}
        model={"emptyData"}
      >
        <div className=" aspect-[3.35/1] relative">
          <div className=" absolute top-0 left-0 right-0 bottom-0">
            <Swiper
              ref={swiperRef}
              className="w-full h-full"
              slidesPerView={"auto"}
              centeredSlides={true}
              autoplay={{
                delay: autoPlayDelay,
                disableOnInteraction: false,
              }}
              grabCursor={true}
              spaceBetween={10}
              navigation={{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              }}
              onSlideChange={handleSlideChange}
              modules={[Autoplay]}
            >
              {sliderData.map((item, index) => {
                return (
                  <SwiperSlide key={index} style={{ width: "100%", backgroundColor: '#22BDE2' }}
                    className="rounded-lg overflow-hidden">
                    <button onClick={() => {
                      if (item.url !== "") {
                        window.open(item.url, "");
                      }
                    }} >
                      <LazyLoadImage
                        src={item.gambar}
                        alt={item.gambar}
                        className=" object-cover flex flex-col flex-1 h-full w-full "
                        effect="blur"
                      />
                    </button>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
        <div className="flex text-center font-bold justify-center items-center space-x-1 -mt-5 z-1 mb-3">
          {Array.from({ length: sliderData.length }).map((_, idx) => (
            <span
              key={idx}
              onClick={() => { }}
              className={`px-2 py-1 cursor-pointer rounded-lg w-10 ${idx === activeSlide ? 'bg-[#22BDE2] text-white' : 'bg-gray-200'}`}
            >
              {/* {idx + 1} */}
            </span>
          ))}
        </div>
      </ConditionalRender>
    </div>
  );
}

export default ImageSlider;

